import { AxiosError } from 'axios';
import { useAuthStore } from '@auth/presentation/store/authStore';

// NOTA: Este servicio es el único responsable de interpretar errores del servidor
// y tomar acciones globales (ej. cerrar sesión en caso de 401).

export const errorService = {
  /**
   * Maneja los errores comunes de la API, como 401 (No autorizado) o 403 (Prohibido).
   * @param error El error de Axios
   */
  handleApiError(error: AxiosError): void {
    const status = error.response?.status;
    const data = error.response?.data as { message?: string };

    if (status === 401) {
      // 401 UNAUTHORIZED: El token no es válido o ha expirado.
      // Forzamos el cierre de sesión y redirigimos al login.
      console.error('Error 401: Token expirado o no válido. Forzando logout.');
      useAuthStore.getState().clearAuth();
      // En un proyecto real, se usaría navigate('/auth/login') de React Router
    } else if (status === 403) {
      // 403 FORBIDDEN: El usuario no tiene permisos.
      console.error('Error 403: Acceso denegado. Permisos insuficientes.', data.message);
    } else if (status && status >= 500) {
      // 5xx: Error del servidor
      console.error(`Error ${status}: Problema en el servidor.`, data.message);
    } else if (status && status >= 400) {
      // 4xx: Errores de negocio (400, 404, 409...) — el componente los maneja, no loguear aquí
    } else {
      // Errores de red o desconocidos (sin response)
      console.error('Error de red o desconocido:', error.message);
    }
  },

  // Podrían añadirse otros métodos aquí como notifyUser(message)
};